import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoorOpenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M13 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7v2H6v20h7Zm4-24.486 9 2.077v20.818l-9 2.077zM15.762 1.2A.753.753 0 0 0 15 2v28a.753.753 0 0 0 .762.8 1 1 0 0 0 .212-.025l11.052-2.55A1.32 1.32 0 0 0 28 27V5a1.32 1.32 0 0 0-.974-1.225l-11.052-2.55a1 1 0 0 0-.212-.025" />
    <path d="M20 15a1 1 0 1 0 0 2 1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconDoorOpenOutlineSVG);
ForwardRef.displayName = "IconDoorOpenOutline";
export { ForwardRef as IconDoorOpenOutline };
